<div class="main-content mt-3" [class.mt-5]="!isMobile()">
    <section class="dashboard">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1>Dashboard</h1>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </section>
</div>